import { StepperLayout } from '@components';
import { withAuth } from '@hoc';
import { Navigate, useLocation } from 'react-router-dom';

import AnotherSubmissionStep from './steps/AnotherSubmissionStep';
import ConditionsChangedStep from './steps/ConditionsChangedStep';
import PersonalDataCheckStep from './steps/PersonalDataCheckStep';
import PersonalDataFormStep from './steps/PersonalDataFormStep';

const PreparingForNextSubmission: React.FC = () => {
  const locaiton = useLocation();

  if (!locaiton.state?.isAccess)
    return <Navigate to="/login" />;

  return (
    <StepperLayout
      steps={[
        { id: '1', title: '1.', content: <AnotherSubmissionStep /> },
        { id: '2.1', title: '2.', content: <PersonalDataCheckStep /> },
        { id: '2.2', title: '2.', content: <PersonalDataFormStep />, isHidden: true },
        { id: '3', title: '3.', content: <ConditionsChangedStep /> },
      ]}
    />
  );
};

export default withAuth(PreparingForNextSubmission);
